import { Injectable } from '@angular/core';
import { DeepLinkStatus } from '@dch/products-business-logic';
import { Subject } from 'rxjs';
import { DISNEY_PLUS_MPUID_CODES, PICKX_DISNEY_PLUS_MPUID_CODES, SCARLET_SPORTS_MPUID_CODES, SPORTS_MPUID_CODES } from '../../constants';

export interface OptionParams {
    option: any;
    selectedProduct: any;
    treatmentCode: string;
    isDeepLink: boolean;
    deepLinkStatus: DeepLinkStatus;
    queryParamToken: string;
}

@Injectable({
    providedIn: 'root'
})
export class OptionDetailsBackgroundService {
    public registerOptionParamsExecutedSubject = new Subject<void>();

    private optionParams: OptionParams;
    public isLoadingState: boolean;
    public isDisabledState: boolean;

    setLoadingState(isLoadingState: boolean) {
        this.isLoadingState = isLoadingState;
    }

    setAllButtonsDisabled(isDisabledState: boolean) {
        this.isDisabledState = isDisabledState;
    }

    registerOptionParams(optionParams: OptionParams) {
        this.optionParams = optionParams;
        this.registerOptionParamsExecutedSubject.next();
    }

    getOptionParams() {
        return this.optionParams;
    }

  isDisneyPlusProduct() {
    const { option } = this.optionParams;
    if (!option) {
      return false;
    }
    return DISNEY_PLUS_MPUID_CODES.includes(option.optionCodeForDescription);
  }

    isPickXDisneyPlusProduct() {
        const { option } = this.optionParams;
      if (!option) {
        return false;
      }
      return  PICKX_DISNEY_PLUS_MPUID_CODES.includes(option.optionCodeForDescription);
    }
    
    isSportsProduct() {
    const { option } = this.optionParams;
    if (!option) {
      return false;
    }
  
    return (
      SPORTS_MPUID_CODES.includes(option.optionCodeForDescription) ||
      SCARLET_SPORTS_MPUID_CODES.includes(option.optionCodeForDescription)
    );
  }

  isScarletSportsProduct() {
    const { option } = this.optionParams;
    if (!option) {
      return false;
    }
   
    return SCARLET_SPORTS_MPUID_CODES.includes(option.optionCodeForDescription);
  }
}
